import {
  createFileRoute,
} from '@tanstack/react-router';

import Logout from '#features/auth/session/Logout';

export const Route = createFileRoute('/_app/auth/logout')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Logout />
  );
}
